import FullInfoField from 'components/FullInfoField/FullInfoField';
import React, { useContext } from 'react';
import {
	RestaurantFullInfoContext,
	IRestaurantFullInfoContext,
} from '../../../../../../../restaurantFullInfoState/restaurantFullInfoContext';

const Tips2Field: React.FC = () => {
	const { restaurantForFullInfo } = useContext<IRestaurantFullInfoContext>(RestaurantFullInfoContext);

	if (restaurantForFullInfo?.defaultTips[2]) {
		return (
			<FullInfoField
				label={restaurantForFullInfo.defaultTips[2].isDefault ? 'tips2DefaultLabel' : 'tips2Label'}
				value={restaurantForFullInfo.defaultTips[2].value}
			/>
		);
	}
	return <FullInfoField label="tips2Label" value={null} />;
};

export default Tips2Field;
